import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps } from 'src/Library/Types';
import {
  Modal,
  Button,
  Row,
  Col,
  Select,
  message,
  Icon,
} from 'src/Library/AntdLibComponents';
import { connect } from 'react-redux';
import { Form13Styles } from './Form13Request.styles';
import { ShipmentData } from 'src/components/pages/shipment-execution/SE.Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { form13FetchVesselMasters } from 'src/api/shipmentExecution';
import { bindActionCreators } from 'redux';
import { setVesselMasters } from 'src/actions/shipmentExecutionActions';
import isEmpty from 'lodash/isEmpty';

interface IProps extends StylesProps<ReturnType<typeof Form13Styles>> {
  isVisible: boolean;
  handleCancel: () => void;
  shipmentData: ShipmentData;
  setVesselMasters: (vesselMaster) => void;
  setDocumentTab: (isDraft?: boolean) => void;
  openForm13Modal: () => void;
}

interface StateProps {
  isLoading?: boolean;
  isNotAcceptingRequestModalVisible?: boolean;
}

const Form13RequestDetailsForm = (props: IProps): React.ReactElement => {

  const {
    classes,
    isVisible,
    handleCancel,
    shipmentData,
    setVesselMasters,
    openForm13Modal,
  } = props;

  const [state, setState] = useGenericState<StateProps>({});

  const {
    isLoading,
    isNotAcceptingRequestModalVisible,
  } = state;

  const handleNext = async () => {
    setState({ isLoading: true });
    const response = await form13FetchVesselMasters(
      shipmentData?.carrierId, (shipmentData?.originPolId || shipmentData?.originPortId)
    );
    if (response.isSuccess) {
      if (!isEmpty(response.data)) {
        setVesselMasters(response.data);
        openForm13Modal();
        setState({ isLoading: false }); 
      } else {
        setState({ isNotAcceptingRequestModalVisible: true, isLoading: false });
      }
    } else {
      message.error(response.errorMessage);
      setState({ isLoading: false }); 
    }
  }

  const renderNotAcceptingRequestModal = () : React.ReactElement => {
    return (
      <Modal
        closable={false}
        className={classes.notAcceptiongRequestModal}
        width={366}
        onCancel={handleCancel}
        zIndex={1200}
        visible={isNotAcceptingRequestModalVisible}
        footer={null}
      >
        <div style={{ marginBottom: '18px' }}>
          <Icon type="exclamation-circle" theme="filled"
            style={{ color: '#FAB826', fontSize: '64px' }} />
        </div>
        <div style={{ fontSize: '18px', marginBottom: '16px' }}>
          Oops!
        </div>
        <div>
          The carrier is not accepting requests for this Shipping Line and POL.
        </div>
        <div style={{ fontSize: '16px', color: '#1875F0', marginTop: '24px' }}>
          <a onClick={handleCancel}>Okay</a>
        </div>
      </Modal>
    );
  };

  return (
    <Modal
      visible={isVisible}
      width={474}
      title="Request Details"
      onCancel={handleCancel}
      footer={
        <React.Fragment>
          <Button
            className={classes.cancelButton}
            size="large"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            className={classes.nextButton}
            size="large"
            onClick={handleNext}
            loading={isLoading}
          >
            Next
          </Button>
        </React.Fragment>
      }
    >
      <div className={classes.requestDetailsMessage}>
        You can submit a request to check for Form 13. If it’s ready, we will notify on the portal.
      </div>
      <Row>
        <Col span={6} className={classes.requestFormLabel}>Shipping Line*</Col>
        <Col span={18}>
          <Select
            value={shipmentData?.carrierName}
            style={{ width: '80%' }}
            disabled={true}
          />
        </Col>
      </Row>
      <Row style={{ margin: '16px 0' }}>
        <Col span={6} className={classes.requestFormLabel}>POL*</Col>
        <Col span={18}>
          <Select
            value={shipmentData?.originPolName || shipmentData?.originPortName}
            style={{ width: '80%' }}
            disabled={true}
          />
        </Col>
      </Row>
      {isNotAcceptingRequestModalVisible && renderNotAcceptingRequestModal()}
    </Modal>
  );
};

const mapDispatchToProps = dispatch => (bindActionCreators({
  setVesselMasters,
}, dispatch));

export default connect(
  null,
  mapDispatchToProps,
)(React.memo(withStyles(Form13Styles)(Form13RequestDetailsForm)));
